import React from 'react';
import Highcharts from 'highcharts';
import { HighchartsReactWithStyles } from './HighchartsReactWithStyles';
import { useRecoilValueLoadable } from 'recoil';
import { agentSummary } from '../../../recoil/selectors/agentSummary';

export function BusinessReportsCharts(props) {
  const agentsSummary = useRecoilValueLoadable(agentSummary);
  const summary =
    agentsSummary.state !== 'loading' ? agentsSummary?.contents : null;
  const options = summary ? summary[`${props.metric}`] : {};

  return (
    <div>
      <HighchartsReactWithStyles
        allowChartUpdate={true}
        highcharts={Highcharts}
        options={JSON.parse(JSON.stringify(options ?? null))}
        loading={agentsSummary.state === 'loading'}
      />
    </div>
  );
}
